import React from 'react';
import { JSONTree } from 'react-json-tree';

const JsonDisplay = ({ jsonData }) => {
  const theme = {
    scheme: 'monokai',
    author: 'wimer hazenberg (http://www.monokai.nl)',
    base00: '#fafafa',
    base01: '#383830',
    base02: '#49483e',
    base03: '#75715e',
    base04: '#a59f85',
    base05: '#f8f8f2',
    base06: '#f5f4f1',
    base07: '#f9f8f5',
    base08: '#f92672',
    base09: '#9a6a06',
    base0A: '#f4bf75',
    base0B: '#58a556',
    base0C: '#a1efe4',
    base0D: '#4278f2',
    base0E: '#ae81ff',
    base0F: '#cc6633',
  };

  const shouldExpandNodeInitially = (keyName, data, level) => {
    return level < 8;
  };

  return (
    <JSONTree
      data={jsonData}
      hideRoot={true}
      theme={theme}
      invertTheme={false}
      shouldExpandNodeInitially={shouldExpandNodeInitially}
    />
  );
};

export default JsonDisplay;
